import React, { useContext } from 'react';
import classnames from 'classnames';
import { PopupContext } from '../../../../Popup/PopupContext';
import s from './PopoverContainer.scss';
var PopoverContainer = React.forwardRef(function (_a, ref) {
    var style = _a.style, placement = _a.placement, className = _a.className, directionalClassNames = _a.directionalClassNames, role = _a.role, ariaLabel = _a["aria-label"], children = _a.children, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave, onKeyDown = _a.onKeyDown;
    var isInPopup = useContext(PopupContext).isInPopup;
    return (React.createElement("div", { ref: ref, style: style, className: classnames(s['root'], directionalClassNames && directionalClassNames[placement], isInPopup && s['in-popup'], className), onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onKeyDown: onKeyDown, 
        // So we can focus the content wrapper when it mounts if necessary
        tabIndex: -1, role: role, "aria-label": ariaLabel }, children));
});
PopoverContainer.displayName = 'PopoverContainer';
export default PopoverContainer;
//# sourceMappingURL=PopoverContainer.js.map